/**
 * Период перед началом сессии когда isLive = true
 */
export const COMINGSOON_PERIOD_IN_MINUTES = 5;

export const STYLES_FROM_CONFIG_NAME = "styles-from-config";